
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface ComponentFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  organizationFilter: string;
  onOrganizationFilterChange: (value: string) => void;
  organizations: Array<{ id: string; name: string }>;
}

export function ComponentFilters({
  searchTerm,
  onSearchChange,
  organizationFilter,
  onOrganizationFilterChange,
  organizations
}: ComponentFiltersProps) {
  return (
    <>
      {/* Filtro de Organizações */}
      <div className="mb-3">
        <Select value={organizationFilter} onValueChange={onOrganizationFilterChange}>
          <SelectTrigger className="w-full bg-sidebar-accent border-sidebar-border text-sidebar-foreground">
            <SelectValue placeholder="Todas as organizações" />
          </SelectTrigger>
          <SelectContent className="bg-popover border-sidebar-border">
            <SelectItem value="todas">Todas</SelectItem>
            {organizations.map((org) => (
              <SelectItem key={org.id} value={org.id}>
                {org.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-sidebar-foreground/50" />
        <Input
          type="text"
          placeholder="Buscar componentes..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10 bg-sidebar-accent border-sidebar-border text-sidebar-foreground placeholder:text-sidebar-foreground/50"
        />
      </div>
    </>
  );
}
